import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FraudCaseDetailView } from '../../fraud-case-details.models';
import { formatCaseDate } from '../../fraud-case-details.utils';

@Component({
  selector: 'app-fraud-case-summary',
  templateUrl: './fraud-case-summary.component.html',
  styleUrls: ['../fraud-case-card.css', './fraud-case-summary.component.css']
})
export class FraudCaseSummaryComponent {
  @Input() caseId = 0;
  @Input() detail: FraudCaseDetailView | null = null;
  @Input() loading = false;
  @Input() error = '';
  @Output() retry = new EventEmitter<void>();
  readonly formatDate = formatCaseDate;
}
